import { BellIcons } from "@assets/icons";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@components/ui/popover";
import { Skeleton } from "@components/ui/skeleton";
import { endpoint } from "@services/api.services";
import Avatar from "@ui/internal/components/avatar-dropdown";
import { formatNumber, LogoutOfSystem } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { IndividualQuery } from "@utils/interface/index.interface";
import { TeamMemberData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore, useUser } from "@utils/states/index.state";
import { MenuIcon, Search } from "lucide-react";
import React, { useEffect, useState } from "react";
import { DateRange } from "react-day-picker";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router";
import { CalendarDatePicker } from "../date-picker-component";
import NotificationsPanel from "../notification";
import { useInfiniteScroller } from "@pages/dashboard/test/hook";
import { useInView } from "react-intersection-observer";
import Cookies from "js-cookie";

const index = () => {
  const { setSearch, clear, date, setDate } = useMetaStore();
  const pathname = usePathname();
  const [searchParams, setSearchParams] = useSearchParams();
  const [text, setText] = useState<string>("");
  useEffect(() => {
    text && searchParams.set("tpage", "1");
    setSearchParams(searchParams);
    const debounce = setTimeout(() => {
      setSearch(text || searchParams.get("search") || "");
      setSearchParams(searchParams);
    }, 1000);

    return () => clearTimeout(debounce);
  }, [text]);

  const location = useLocation();
  useEffect(() => {
    setText(() => "");
    clear();
  }, [location.pathname]);
  let {
    data,
    isPending,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteScroller({
    endpoint: "/notification",
    enabled: true,
  });
  // console.log("asdasdasdasd:", data);
  const notificationData =
    data?.pages.flatMap((page: any) => page.results) || [];
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);
  const { user, setUser, setIsPending } = useUser();
  const { data: userData } = useListData<IndividualQuery<TeamMemberData>>({
    key: "auth",
    endpoint: endpoint["userme"],
    enabled:
      Cookies.get("access") || sessionStorage.getItem("access") ? true : false,
  });
  useEffect(() => {
    setIsPending(true);
    if (userData) {
      console.log("USERDAT", userData);
      setUser(userData.data);
      setIsPending(false);
    }
  }, [userData]);
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between">
      <span className="text-[clamp(20px,6vw,30px)] flex gap-2 text- text-gray-700 capitalize font-semibold">
        {/* Hello, {full_name?.split(" ")[0]} */}
        Hello,{" "}
        {Object.keys(user).length === 0 ? (
          <Skeleton className="w-[100px]  h-[45px]" />
        ) : (
          <div className="max-w-[200px] w-fit truncate">
            {user?.first_name || user?.username}
          </div>
        )}
        <span className="animate-wave  cursor-pointer hover:animate-pulse">
          👋
        </span>
      </span>
      <div className="max-md:flex gap-3 items-center hidden">
        <Popover>
          {" "}
          <PopoverTrigger className="cursor-pointer relative">
            <BellIcons />
            {/* @ts-ignore */}
            {data?.pages[0]?.total_unread > 0 && (
              <div className="absolute -top-7 left-4 bg-[#e8f6f1] size-7 flex items-center justify-center text-sm rounded-full text-[#1a926c]">
                {" "}
                {/* @ts-ignore */}
                {formatNumber(data?.pages[0]?.total_unread)}
              </div>
            )}
          </PopoverTrigger>
          <PopoverContent className="w-full bg-transparent border-none shadow-none">
            <NotificationsPanel
              ref={ref}
              notificationData={notificationData}
              isPending={isPending}
              isFetchingNextPage={isFetchingNextPage}
              refetch={refetch}
            />
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger asChild>
            <Button variant={"outline"}>
              <MenuIcon />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-full">
            {" "}
            <div className="relative flex flex-col gap-4 items-start">
              <Input
                startIcon={<Search color="#A3A3A3" />}
                className="w-full   justify-start text-left font-normal"
                placeholder="Search"
                value={text || searchParams.get("search") || ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setText(e.target.value);
                  searchParams.set("search", e.target.value);
                  setSearchParams(() => searchParams);
                }}
              />
              <CalendarDatePicker
                date={date as DateRange}
                onDateSelect={setDate}
                variant={"outline"}
                className="w-full"
              />
              <div className="flex w-full gap-4">
                <Link to="/profile" className="flex-1">
                  <Button variant={"ghost"} className="border w-full">
                    Profile
                  </Button>
                </Link>
                <Button
                  className="flex-1"
                  variant={"destructive"}
                  onClick={() => {
                    LogoutOfSystem();
                    navigate("/login");
                    setIsPending(true);
                  }}
                >
                  Logout
                </Button>
              </div>
            </div>
          </PopoverContent>
        </Popover>
      </div>

      <div className="flex max-md:hidden gap-2">
        <div className="relative flex gap-4 items-center">
          {["add", "edit"].includes(searchParams.get("page") || "") ||
          ["privacy-policy", "terms-&-condition"].includes(pathname) ? (
            <></>
          ) : (
            <>
              {" "}
              <Input
                startIcon={<Search color="#A3A3A3" />}
                className="w-[190px] justify-start text-left font-normal"
                placeholder="Search"
                value={text || searchParams.get("search") || ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setText(e.target.value);
                  searchParams.set("search", e.target.value);
                  setSearchParams(() => searchParams);
                }}
              />
              <CalendarDatePicker
                date={date as DateRange}
                onDateSelect={setDate}
                variant={"outline"}
              />
            </>
          )}
          <Popover>
            <PopoverTrigger className="cursor-pointer relative">
              <BellIcons />
              {/* @ts-ignore */}
              {/* @ts-ignore */}
              {data?.pages[0]?.total_unread > 0 && (
                <div className="absolute -top-7 left-4 bg-[#e8f6f1] size-7 flex items-center justify-center text-sm rounded-full text-[#1a926c]">
                  {" "}
                  {/* @ts-ignore */}
                  {formatNumber(data?.pages[0]?.total_unread)}
                </div>
              )}
            </PopoverTrigger>
            <PopoverContent className="w-full bg-transparent border-none shadow-none">
              <NotificationsPanel
                ref={ref}
                notificationData={notificationData}
                isPending={isPending}
                isFetchingNextPage={isFetchingNextPage}
                refetch={refetch}
              />
            </PopoverContent>
          </Popover>
          <Avatar
            role={
              user?.is_superuser
                ? "Super Admin"
                : user?.is_staff
                ? "Team Member"
                : "Regular "
            }
            username={
              Object.keys(user).length === 0 ? (
                <Skeleton className="w-[70px] h-[20px]" />
              ) : (
                (user?.first_name as string) || user?.username
              )
            }
            avatar={user?.professional_image as string}
          />
        </div>
      </div>
    </div>
  );
};

export default index;
